import { PartnerRepository } from "@/infrastructure/repositories/PartnerRepository";
import { UserRepository } from "@/infrastructure/repositories/UserRepository";
import { QuestionaireRepository } from "@/infrastructure/repositories/QuestionaireRepository";
import AIFilesService from "@/services/AIFilesService";
import ContentsService from "@/services/ContentsService";
import CouponsService from "@/services/CouponsService";
import MedicalRecordsService from "@/services/MedicalRecordsService";
import MedicinesService from "@/services/MedicinesService";
import PatientsService from "@/services/PatientsService";
import PrescriptionsService from "@/services/PrescriptionsService";
import UserService from "@/services/UserService";
import dataSources from "./dataSources";
import adapters from "./adapters";

export default {
    prescriptionsService: new PrescriptionsService(adapters.network),
    medicalRecordsService: new MedicalRecordsService(adapters.network),
    patientsService: new PatientsService(adapters.network),
    aiFilesService: new AIFilesService(adapters.network),
    medicinesService: new MedicinesService(adapters.network),
    contentsService: new ContentsService(adapters.network),
    userService: new UserService(adapters.network),
    couponsService: new CouponsService(adapters.network),
    partnerRepository: new PartnerRepository(dataSources.partnerDataSource),
    userSubscriptionHistoryRepository: new UserRepository(dataSources.userSubscriptionHistoryDataSource),
    questionaireRepository: new QuestionaireRepository(dataSources.questionaireDataSource),
}